import { handleVersionMismatch } from 'actions/versionSync';
import * as UserActionTypes from 'actiontypes/user';
import { VersionMismatch } from 'services/BaseService';
import userService from 'services/UserService';
import { bootstrap } from 'actions/app';

import handleAccessCodeResult from './handleAccessCodeResult';
import setJwt from './setJwt';
import createBootstrapOptions from 'actions/user/createBootstrapOptions';

const UserService = new userService();

/** ----------------------------------------------------------------------------
 * Google Login
 -----------------------------------------------------------------------------*/
export default function googleLogin(token) {
  return async (dispatch, getState) => {
    dispatch(googleLoginRequested());

    // Get access code from state
    const { accessCodes: { accessCode } } = getState();
    const accessCodeName = accessCode.name;

    try {
      const { data } = await UserService.googleLogin({ token, accessCodeName });
      const { hasCharacter, isSuccess } = data;

      // TODO: login failed, so communicate this to the user
      if (!isSuccess) {
        dispatch(googleLoginFailure(data));
        return;
      }
      // Set our JWT
      setJwt(window, data);

      // Notify Redux that login succeeded
      dispatch(googleLoginSuccess(data));

      if (hasCharacter) {
        // Bootstrap app state
        dispatch(bootstrap(createBootstrapOptions(dispatch)));
        // Handle access code result
        dispatch(handleAccessCodeResult(data));
      }

      // Return data for caller to use
      return data;
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
        return;
      }
      dispatch(googleLoginError(error));
    }
  };
}

const googleLoginRequested = () => ({
  type: UserActionTypes.GOOGLE_LOGIN_REQUESTED,
});

const googleLoginSuccess = data => ({
  type: UserActionTypes.GOOGLE_LOGIN_SUCCESS,
  payload: {
    accessCodeResult: data.accessCodeResult,
    user: data.user,
  },
});

const googleLoginError = error => ({
  error,
  type: UserActionTypes.GOOGLE_LOGIN_ERROR,
  loginError: true,
  status: error.response && error.response.status,
});

const googleLoginFailure = data => ({
  type: UserActionTypes.GOOGLE_LOGIN_FAILURE,
  payload: data,
});